export default "__VITE_ASSET__DNrYP83L__"